import styled from "styled-components";

export const SuggestionsContainer = styled.div`
  min-height: 100vh;
`
export const SuggestionsHeader = styled.div``
export const SuggestionsForm = styled.form``
export const Suggestions = styled.div``
export const SuggestionsGroup = styled.div``
